import React from 'react';
import Modal from '../../components/book/steps/components/Modal';
import SignUpSignInForm from '.';
import styled from '@emotion/styled'

const Container = styled.div`
  padding: 16px;
  padding-bottom: 60px;

  h1 {
    margin: 20px 0 !important;
  }
`

const SignInModal = ({ isOpen, close, isDesktop }) => {
  return (
    <Modal
      fullHeight={true}
      isOpen={isOpen}
      closeModal={close}
      isDesktop={isDesktop}
      width='800px'
    >
      <Container>
        <SignUpSignInForm
          id="auth-forms"
          showHeadlines={true}
          initSignUpForm={false}
          onSuccess={() => {
            close()
          }}
        />
      </Container>
    </Modal>
  );
};

export default SignInModal;
